// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttons {
  display: none;
  flex-direction: column;
  gap: 0.5rem;
  align-self: flex-end;
  margin-bottom: 70px;
}

.sidebar {
  height: 100% !important;
  background-color: white;
  border-radius: 2px;
  border: none;
  width: 100%;
  overflow-y: auto;
  pointer-events: all;
}
@media screen and (min-width: 600px) {
  .sidebar {
    width: 80%;
  }
}

.transform {
  transform: translateX(0px) !important;
}

.container {
  height: 100%;
  width: 100%;
  max-width: 100%;
  z-index: 99999;
  display: flex;
  flex-direction: row;
  position: fixed;
  right: 0;
  top: 0%;
  left: inherit;
  transition: all 330ms ease;
  transform: translateX(86%);
  pointer-events: all;
}
@media screen and (min-width: 600px) {
  .container {
    max-width: 500px;
  }
}
@media screen and (max-width: 400px) {
  .container {
    transform: translateX(82%);
  }
}
@media screen and (min-width: 400px) and (max-width: 600px) {
  .container {
    transform: translateX(88%);
  }
}

@media screen and (min-width: 600px) {
  .sidebar {
    width: 800px;
  }
  .buttons {
    display: flex;
    width: 20%;
  }
  .show-buttons {
    display: flex;
  }
}
.margin-right-25 {
  margin-right: 25%;
}

.show-buttons {
  display: flex;
}

.consultant-flybtn {
  height: 30px;
  width: 30px;
}

.consultant-flybtn-original {
  height: 30px;
  width: 30px;
}

.consultant-flybtn path {
  stroke: white;
}

.consultant-flybtn-original path {
  stroke: #e60000;
}

.flybtn {
  background-color: #e60000 !important;
  left: 15%;
  padding-top: 13px !important;
  padding-right: 10px !important;
  width: 30% !important;
  height: 50px;
  min-width: 60px !important;
}
@media screen and (max-width: 600px) {
  .flybtn {
    visibility: hidden;
  }
}

.button-top-margin {
  top: 0.5em;
}

.button-bottom-margin {
  bottom: 0.5em;
}

.flybtn-original {
  background-color: #fff !important;
  padding-top: 13px !important;
  padding-right: 10px !important;
  left: 15%;
  height: 50px;
  width: 30% !important;
  min-width: 60px !important;
}

.contentStyleTitle {
  font-size: 48px;
  color: black;
}

.contentStyleLine1 {
  font-size: 36px;
  color: #4A4D4E;
}

.contentStyleLine2 {
  font-size: 15px;
}

.contentStyleLine3 {
  font-size: 16px;
  line-height: 1.5em;
}

.button-style {
  background-color: #e60000 !important;
  width: 95%;
  height: 3.5em;
  font-weight: bold !important;
  text-decoration: none !important;
  font-size: 14px !important;
  text-transform: capitalize !important;
  margin-top: 1em !important;
  margin-bottom: 1em !important;
}

.call-link {
  font-weight: bold;
  text-decoration: none;
  font-size: 14px;
  text-transform: capitalize;
}

.call-link.call-link:hover, .call-link:visited, .call-link:link {
  color: #fff !important;
  font-weight: bold;
  text-decoration: none;
}

.close-button {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: white;
  border-color: white;
  box-shadow: white;
  margin-left: 350px;
  box-shadow: 0 1px 3px rgba(51, 51, 51, 0.6);
  z-index: -1;
  margin-top: 2em;
  margin-left: 80%;
}

.dialog-margin {
  margin-left: 1.5em;
  color: #2e2e2e;
}

.dialog-margin-top {
  margin-top: 15px;
}

.whatsappQr {
  margin-left: 15%;
}

.mobile-button {
  top: -1em;
  background-color: #e60000 !important;
}
@media screen and (min-width: 600px) {
  .mobile-button {
    visibility: hidden;
  }
}

.mobilepopup-title {
  font-size: 30px;
}

.mobilepopup-line1 {
  font-size: 24px;
  margin-bottom: 30px;
}

.mobilepopup-line2 {
  font-size: 16px;
  margin-bottom: 20px;
}

.mobile-button-style {
  background-color: #fff;
  color: black;
  border: #e60000;
  height: 60px;
  width: 100%;
  font-weight: bold;
  text-decoration: none;
  box-shadow: 0 1px 3px rgba(50, 50, 50, 0.6);
  font-size: 16px;
}

.mobileCallButtonStyle {
  font-size: 16px;
  color: #fff;
  background-color: #e60000;
  margin-bottom: 10px;
  border: #e60000;
  height: 40px;
  width: 100%;
  font-weight: bold;
  text-decoration: none;
}

.backButtonStyle {
  font-size: 16px;
  background-color: #fff;
  margin-bottom: 10px;
  color: black;
  border: #e60000;
  height: 40px;
  width: 100%;
  font-weight: bold;
  text-decoration: none;
  box-shadow: 0 1px 3px rgba(50, 50, 50, 0.6);
}

.buttonText {
  margin-top: -30px;
  margin-bottom: 22px;
  font-size: 14px;
}
@media screen and (min-width: 500px) {
  .buttonText {
    margin-top: -30px;
    font-size: 14px;
    margin-bottom: 20px;
  }
}

.popup-button {
  height: 50px;
  margin-right: 250px;
  margin-top: 5px;
}
@media screen and (min-width: 500px) {
  .popup-button {
    margin-left: -140px;
  }
}

.flyout_button-mobile {
  right: 0px;
  z-index: 2;
  height: 70px;
  width: 60px;
  background: #e60000;
  bottom: 96px;
  position: fixed;
  left: auto;
  border: #e60000;
  color: white;
  padding: 10px 15px 15px 15px;
  font-size: 10px;
}

.mobileButtonStyle {
  border: #fff;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(51, 51, 51, 0.6);
  width: 95%;
}

.mobilePopupTitle {
  font-size: 30px;
  color: #2e2e2e;
  margin-bottom: 10px;
}

.mobilePopupLine1 {
  font-size: 24px;
  color: #2e2e2e;
}

.mobilePopupLine2 {
  font-size: 16px;
  color: #2e2e2e;
  margin-bottom: 20px;
}

.back-button {
  background-color: #fff !important;
  width: 95%;
  height: 3.5em;
  text-transform: capitalize;
  color: black !important;
  font-weight: bold !important;
}

.kontakt-button {
  background-color: #e60000 !important;
  color: white;
  font-size: 10.5px !important;
  text-align: center !important;
  text-transform: capitalize !important;
  bottom: 3.2em;
}
@media screen and (min-width: 600px) {
  .kontakt-button {
    visibility: hidden;
  }
}

.flyout-parent {
  position: fixed;
  width: 90vw;
  height: 100vh;
  top: 0;
  pointer-events: none;
}

.scrollHidden {
  position: fixed;
}

.scrollVisible {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/flyout/flyout.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAAI;EARF;IASI,UAAA;EAGJ;AACF;;AAAE;EACE,qCAAA;AAGJ;;AAAE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,0BAAA;EACA,0BAAA;EACA,mBAAA;AAGJ;AAFI;EAdF;IAeM,gBAAA;EAKN;AACF;AAJI;EAjBF;IAkBI,0BAAA;EAOJ;AACF;AANE;EApBA;IAqBI,0BAAA;EASJ;AACF;;AANE;EACE;IACE,YAAA;EASJ;EANE;IACE,aAAA;IACA,UAAA;EAQJ;EALE;IACE,aAAA;EAOJ;AACF;AAJE;EACE,iBAAA;AAMJ;;AAHE;EACE,aAAA;AAMJ;;AAJE;EACE,YAAA;EACA,WAAA;AAOJ;;AALE;EACE,YAAA;EACA,WAAA;AAQJ;;AANE;EACE,aAAA;AASJ;;AANE;EACA,eAAA;AASF;;AANE;EACE,oCAAA;EACA,SAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;EACA,0BAAA;AASJ;AARI;EARF;IASM,kBAAA;EAWN;AACF;;AATE;EACE,UAAA;AAYJ;;AAVE;EACE,aAAA;AAaJ;;AAXE;EACE,iCAAA;EACA,4BAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,0BAAA;AAcJ;;AAZE;EACE,eAAA;EACA,YAAA;AAeJ;;AAbE;EACE,eAAA;EACA,cAAA;AAgBJ;;AAdE;EACE,eAAA;AAiBJ;;AAfE;EACE,eAAA;EACA,kBAAA;AAkBJ;;AAfE;EACE,oCAAA;EACA,UAAA;EACA,aAAA;EACA,4BAAA;EACA,gCAAA;EACA,0BAAA;EACA,qCAAA;EACA,0BAAA;EACA,6BAAA;AAkBJ;;AAhBE;EACE,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,0BAAA;AAmBJ;;AAjBE;EACE,sBAAA;EACA,iBAAA;EACA,qBAAA;AAoBJ;;AAlBE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2CAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAqBJ;;AAnBE;EACE,kBAAA;EACA,cAAA;AAsBJ;;AApBE;EACE,gBAAA;AAuBJ;;AArBE;EACE,gBAAA;AAwBJ;;AAtBE;EACE,SAAA;EACA,oCAAA;AAyBJ;AAxBI;EAHF;IAIM,kBAAA;EA2BN;AACF;;AAzBE;EACE,eAAA;AA4BJ;;AA1BG;EACC,eAAA;EACA,mBAAA;AA6BJ;;AA3BE;EACE,eAAA;EACA,mBAAA;AA8BJ;;AA5BE;EACE,sBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,2CAAA;EACA,eAAA;AA+BJ;;AA7BE;EACE,eAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;AAgCJ;;AA9BE;EACE,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,2CAAA;AAiCJ;;AA/BE;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;AAkCJ;AAjCI;EAJF;IAKE,iBAAA;IACI,eAAA;IACA,mBAAA;EAoCN;AACF;;AAjCE;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAoCJ;AAnCI;EAJF;IAKI,mBAAA;EAsCJ;AACF;;AApCE;EACE,UAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AAuCJ;;AArCE;EACI,YAAA;EACA,sBAAA;EACA,2CAAA;EACA,UAAA;AAwCN;;AAtCE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAyCJ;;AAvCE;EACE,eAAA;EACA,cAAA;AA0CJ;;AAxCE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AA2CJ;;AAzCE;EACE,iCAAA;EACA,UAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,4BAAA;AA4CJ;;AA1CE;EACE,oCAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,qCAAA;EACA,aAAA;AA6CJ;AA5CI;EAPF;IASM,kBAAA;EA8CN;AACF;;AA5CE;EACI,eAAA;EACD,WAAA;EACA,aAAA;EACE,MAAA;EACA,oBAAA;AA+CP;;AA7CA;EACE,eAAA;AAgDF;;AA9CA;EACE,kBAAA;AAiDF","sourcesContent":[".buttons {\n    display: none;\n    flex-direction: column;\n    gap: 0.5rem;\n    align-self: flex-end;\n    margin-bottom: 70px;\n  }\n  \n  .sidebar {\n    height: 100% !important;\n    background-color: white;\n    border-radius: 2px;\n    border: none;\n    width: 100%;\n    overflow-y: auto;\n    pointer-events: all;\n    @media screen and (min-width: 600px){\n      width: 80%;\n    }\n  }\n  \n  .transform {\n    transform: translateX(0px) !important;\n  }\n  \n  .container {\n    height: 100%;\n    width: 100%;\n    max-width: 100%;\n    z-index: 99999;\n    display: flex;\n    flex-direction: row;\n    position: fixed;\n    right: 0;\n    top: 0%;\n    left: inherit;\n    transition: all 330ms ease;\n    transform: translateX(86%);\n    pointer-events: all;\n    @media screen and (min-width: 600px){\n        max-width: 500px;\n    }\n    @media screen and (max-width: 400px){\n      transform: translateX(82%);\n  }\n  @media screen and (min-width: 400px) and (max-width: 600px){\n      transform: translateX(88%);\n  }\n  }\n  \n  @media screen and (min-width: 600px) {  \n    .sidebar{\n      width: 800px;\n    }\n  \n    .buttons{\n      display: flex;\n      width: 20%;\n    }\n  \n    .show-buttons{\n      display: flex;\n    }  \n  }\n  \n  .margin-right-25{\n    margin-right: 25%;\n  }\n  \n  .show-buttons {\n    display: flex;\n  }\n  .consultant-flybtn {\n    height: 30px;\n    width:30px;\n  }\n  .consultant-flybtn-original {\n    height: 30px;\n    width:30px;\n  }\n  .consultant-flybtn path{\n    stroke:white;\n  }\n  \n  .consultant-flybtn-original path {\n  stroke: #e60000;\n  }\n\n  .flybtn {\n    background-color: #e60000 !important;\n    left: 15%;\n    padding-top: 13px !important;\n    padding-right: 10px !important;\n    width: 30% !important;\n    height: 50px;\n    min-width: 60px !important;\n    @media screen and (max-width: 600px){\n        visibility: hidden;\n    }\n  }\n  .button-top-margin {\n    top: 0.5em;\n  }\n  .button-bottom-margin {\n    bottom: 0.5em;\n  }\n  .flybtn-original {\n    background-color: #fff !important;\n    padding-top: 13px !important;\n    padding-right: 10px !important;\n    left: 15%;\n    height: 50px;\n    width: 30% !important;\n    min-width: 60px !important;\n  }\n  .contentStyleTitle {\n    font-size: 48px;\n    color: black;\n  };\n  .contentStyleLine1 {\n    font-size: 36px;\n    color:#4A4D4E;\n  };\n  .contentStyleLine2 {\n    font-size: 15px;\n  };\n  .contentStyleLine3 {\n    font-size: 16px;\n    line-height: 1.5em;\n  };\n\n  .button-style {\n    background-color: #e60000 !important;\n    width: 95%;\n    height: 3.5em;\n    font-weight: bold !important;\n    text-decoration: none !important;\n    font-size: 14px !important;\n    text-transform: capitalize !important;\n    margin-top: 1em !important;\n    margin-bottom: 1em !important;\n  }\n  .call-link{\n    font-weight: bold;\n    text-decoration: none;\n    font-size: 14px;\n    text-transform: capitalize;\n  }\n  .call-link.call-link:hover, .call-link:visited, .call-link:link{\n    color: #fff !important;\n    font-weight: bold;\n    text-decoration: none\n  }\n  .close-button {\n    height: 40px;\n    width: 40px;  \n    border-radius: 50%;\n    background-color: white;\n    border-color: white;\n    box-shadow: white;\n    margin-left: 350px;\n    box-shadow: 0 1px 3px rgb(51 51 51 / 60%);\n    z-index: -1;\n    margin-top: 2em;\n    margin-left: 80%;\n  }\n  .dialog-margin{\n    margin-left: 1.5em;\n    color: #2e2e2e;\n  }\n  .dialog-margin-top {\n    margin-top: 15px;\n  }\n  .whatsappQr{\n    margin-left: 15%;\n  }\n  .mobile-button {\n    top: -1em;\n    background-color: #e60000 !important;\n    @media screen and (min-width: 600px){\n        visibility: hidden;\n    }\n  }\n  .mobilepopup-title  {\n    font-size: 30px;\n  }\n   .mobilepopup-line1 {\n    font-size: 24px;\n    margin-bottom: 30px;\n  }\n  .mobilepopup-line2 {\n    font-size: 16px;\n    margin-bottom: 20px;\n  }\n  .mobile-button-style {\n    background-color: #fff;\n    color: black;\n    border: #e60000;\n    height: 60px;\n    width: 100%;\n    font-weight: bold;\n    text-decoration: none;\n    box-shadow: 0 1px 3px rgba(50, 50, 50, 0.6);\n    font-size:16px;\n  }\n  .mobileCallButtonStyle {\n    font-size: 16px;\n    color: #fff;\n    background-color: #e60000;\n    margin-bottom: 10px;\n    border: #e60000;\n    height: 40px;\n    width: 100%;\n    font-weight: bold;\n    text-decoration: none;\n  }\n  .backButtonStyle {\n    font-size: 16px;\n    background-color: #fff;\n    margin-bottom: 10px;\n    color: black;\n    border: #e60000;\n    height: 40px;\n    width: 100%;\n    font-weight: bold;\n    text-decoration: none;\n    box-shadow: 0 1px 3px rgba(50, 50, 50, 0.6);\n  }\n  .buttonText{\n    margin-top: -30px;\n    margin-bottom: 22px;\n    font-size: 14px;\n    @media screen and (min-width: 500px){\n    margin-top: -30px;\n        font-size: 14px;\n        margin-bottom: 20px;\n  }\n  }\n\n  .popup-button{\n    height: 50px;\n    margin-right: 250px;\n    margin-top: 5px;\n    @media screen and (min-width: 500px){\n      margin-left: -140px;\n  }\n  }\n  .flyout_button-mobile{\n    right: 0px;\n    z-index: 2;\n    height: 70px;\n    width: 60px;\n    background: #e60000;\n    bottom: 96px;\n    position: fixed;\n    left: auto;  \n    border: #e60000;\n    color: white;\n    padding: 10px 15px 15px 15px;\n    font-size: 10px;\n  }\n  .mobileButtonStyle {\n      border:#fff;\n      background-color: #fff;\n      box-shadow: 0 1px 3px rgb(51 51 51 / 60%);\n      width: 95%;\n  }\n  .mobilePopupTitle {\n    font-size: 30px;\n    color: #2e2e2e;\n    margin-bottom: 10px;\n  };\n  .mobilePopupLine1 {\n    font-size: 24px;\n    color: #2e2e2e;\n  };\n  .mobilePopupLine2 {\n    font-size: 16px;\n    color: #2e2e2e;\n    margin-bottom: 20px;\n  };\n  .back-button {\n    background-color: #fff !important;\n    width: 95%;\n    height: 3.5em;\n    text-transform: capitalize;\n    color: black !important;\n    font-weight: bold !important\n  }\n  .kontakt-button {\n    background-color: #e60000 !important;\n    color: white;\n    font-size: 10.5px !important;\n    text-align: center !important;\n    text-transform: capitalize !important;\n    bottom: 3.2em;\n    @media screen and\n     (min-width: 600px){\n        visibility: hidden;\n    }\n}\n  .flyout-parent { \n      position: fixed;\n     width: 90vw; \n     height: 100vh;\n       top: 0;\n       pointer-events: none;\n  }\n.scrollHidden {\n  position: fixed;\n}\n.scrollVisible{\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
